<template>
  <div>
    <b-modal
      id="modal-workers"
      ref="modal_workers_select"
      :title="title"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      modal-class="custom-modal"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
      @hidden="onHidden"
    >
      <b-row class="mb-0">
        <b-col cols="10">
          <b-form>
            <div class="page-body">
              <div class="page-filters">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <b-input-group>
                      <b-form-input size="sm" v-model="query" :placeholder="$t('message.common.search')" @input="onInput"/>
                      <b-input-group-append>
                        <button type="button" class="search-btn" @click.stop="onSearch()">
                          <v-icon name="buttons/search"/>
                        </button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div>
                    <b-form-select class="ml-3" id="input-town" size="sm" v-model="currentTown" @change="onTownChange()">
                      <option :value="-1">Все города</option>
                      <option v-for="option in towns" :key="option.id" :value="option.id">
                        {{ option.name }}
                      </option>
                    </b-form-select>
                  </div>
                </div>
              </div>

              <template v-if="isBusy || (items && items.length > 0)">
                <div class="page-table-container">
                  <b-table
                    id="workers"
                    class="custom-table text-small mb-0"
                    responsive
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    @row-clicked="rowClicked"
                    :tbody-tr-class="tbodyRowClass"
                    no-provider-filtering
                    no-provider-paging
                    no-provider-sorting
                  >
                    <template #table-busy>
                      <tables-skeleton :fields="fields" :rows="5"/>
                    </template>

                    <template #cell(phone)="row">
                      <a :href=telUrl(row.item.phone) style="color: #1A9167 !important;">{{ phoneString(row.item.phone) }}</a>
                    </template>

                    <template #cell(passport_url)="row">
                      <a v-if="row.item.passport_url.length > 0" @click="downloadFile(row.item.id, row.item.passport_url)">
                        <v-icon name="buttons/passport" :size="19" :style="{color:'#1A9167'}"/>
                      </a>
                    </template>

                    <template #cell(level_efficiency)="row">
                      <span :id="'level-efficiency-badge-' + row.item.id" :class="['custom-tag', getLevelEfficiencyStyle(row.item.level_efficiency)]">
                        {{getLevelEfficiencyText(row.item.level_efficiency)}}
                      </span>
                      <b-tooltip
                        v-if="row.item.description !== ''"
                        :target="'level-efficiency-badge-' + row.item.id"
                        triggers="hover"
                        :variant="getLevelEfficiencyStyle(row.item.level_efficiency)"
                        noninteractive
                      >
                        {{ row.item.description }}
                      </b-tooltip>
                    </template>

                    <template #cell(risk)="row">
                      <worker-risk :employment-type="row.item.employment_type" :risk="workerRisks[row.item.id]" />
                    </template>

                    <template #cell(employment_type)="row">
                      {{getEmploymentTypeText(row.item.employment_type)}}
                    </template>
                  </b-table>
                </div>

                <div class="page-pagination">
                  <pagination-footer
                    :total-rows="totalRows"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @page-change="onPageChange"
                    @per-page-change="onPerPageChange"
                  >
                    <template #footer-list>
                      <div>
                        Всего исполнителей: <b>{{totalRows}}</b>
                      </div>
                    </template>
                    <template #footer-per-page>
                      <span/>
                    </template>
                  </pagination-footer>
                </div>
              </template>

              <div v-else class="empty-state-container">
                <v-icon name="navbar/empty_table" :size="90"/>
                <h5>{{ isFiltered ? 'Нет данных соответствующих фильтрам.' : 'Нет добавленных исполнителей.' }}</h5>
              </div>
            </div>
          </b-form>
        </b-col>
        <b-col cols="2">
          <div class="sticky-info">
          <h6>Будут добавлены: {{ selectedItems.length }}</h6>
          <div v-for="(item, index) in selectedItems" :key="item.id">
            <small>{{ item.name }}</small>
          </div>
          <hr/>
          <h6>Уже в заявке: {{ tws.length }}</h6>
          <div v-for="(item, index) in tws" :key="item.id">
            <small>{{ item.name }}</small>
          </div>
          </div>
        </b-col>
      </b-row>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="hideModal">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="isBusy" @click="rowClickHandler">
            Добавить в заявку
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import WorkerRisk from "./WorkerRisk.vue";
import workerRisks from "../../utilites/workerRisks";
import workers from "../../network/workers";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import {debounce} from "lodash";
import TablesSkeleton from "../../utilites/commonUi/TablesSkeleton.vue";

export default {
  name: "WorkersFree",
  components: { WorkerRisk, TablesSkeleton, PaginationFooter },
  mixins: [
    workerRisks,
    workers, catalogs,
    helpers, pageSearchService
  ],
  props: {
    locationId: { type: Number, default: 0 },
    workers: { type: Array, default: () => [] },
  },
  data() {
    return {
      title: 'Исполнители',
      formUrl: 'workers',
      isBusy: false,
      items: [],
      fields: [
        { key: 'risk', label: 'Риск', visible: true, sortable: false },
        {
          key: 'name',
          label: this.$t('message.workers.table.name'),
          sortable: true,
          class: 'actions-width'
        },
        {
          key: 'phone',
          label: this.$t('message.workers.table.phone'),
          sortable: true,
        },
        {
          key: 'address',
          label: this.$t('message.workers.table.address'),
          sortable: true,
        },
        {
          key: 'passport_url',
          label: this.$t('message.workers.table.passport'),
          class: 'text-center',
          sortable: true,
          formatter: 'existPassport',
        },
        {
          key: 'age',
          label: this.$t('message.workers.table.age'),
          sortable: true,
        },
        {
          key: 'skill',
          label: this.$t('message.workers.table.skill'),
          sortable: true,
        },
        {
          key: 'ready',
          label: this.$t('message.workers.table.ready'),
          sortable: true,
        },
        {
          key: 'level_efficiency',
          label: 'Ур.КПД',
          sortable: true,
          visible: true
        },
        {
          key: 'employment_type',
          label: "Тип занятости",
          sortable: true,
          visible: true,
        },
      ],
      sortBy: 'last_task_end_date',
      sortDesc: true,
      query: '',
      perPage: 150,
      currentTown: -1,
      disableRouting: true,
      towns: [],
      selectedItems: [],
      tws: [],
      levelEfficiencyOptions: [
        { value: 'high', text: 'Высокий' },
        { value: 'medium', text: 'Средний' },
        { value: 'low', text: 'Низкий' },
      ],
      employmentTypes: [
        { value: null, text: 'Не выбран' },
        { value: 1, text: 'СМЗ' },
        { value: 2, text: 'ГПХ' },
        { value: 3, text: 'ФЛ' },
        { value: 4, text: 'ИП' },
        { value: 5, text: 'В штате' },
      ],
    }
  },
  async created() {
    this.towns = (await this.getTowns({})).data.items;

    await this.getItems();

    this.debouncedSearch = debounce(() => {
      this.onSearch();
    }, 300);
  },
  computed: {
    isFiltered() {
      return !!this.query && this.query.trim().length > 0;
    },
  },
  methods: {
    async showModalSelect() {
      this.tws = this.workers || [];
      this.$refs.modal_workers_select.show();
      await this.getItems();
    },
    onHidden() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.selectedItems = [];
      this.currentTown = -1;
      this.query = '';
    },
    hideModal() {
      this.$refs.modal_workers_select.hide();
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query,
        town: this.currentTown,
        active: true,
        level_efficiency: '',
      }

      this.isBusy = true;
      const result = await this.getWorkers(data);

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.loadWorkerRisks((this.items || []).map(worker => worker.id), this.locationId);
      this.totalRows = result.data.total;

      this.updateSelected();
      this.isBusy = false;
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach(item => {
        const isAssigned = this.tws.some(e => e.worker_id === item.id);
        const isSelected = this.selectedItems.some(e => e.id === item.id);

        this.$set(item, 'selected', isSelected);

        item._rowVariant = isAssigned ? 'danger' : '';
      });
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    rowClicked(item) {
      // Ищем уже добавленные в заявку
      if (this.tws.some(e => e.worker_id === item.id)) {
        return;
      }
      // Ищем уже выбранные
      const existItem = this.selectedItems.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.selectedItems.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.selectedItems.push(item);
        this.$set(item, 'selected', true);
      }
    },
    rowClickHandler() {
      this.$emit('addToTask', this.selectedItems);
      this.hideModal();
    },
    existPassport(value) {
      return value.length > 0;
    },
    onInput() {
      this.debouncedSearch();
    },
    async onTownChange() {
      this.currentPage = 1;
      await this.getItems();
    },
    getLevelEfficiencyText(value) {
      const option = this.levelEfficiencyOptions.find(opt => opt.value === value);
      return option.text;
    },
    getLevelEfficiencyStyle(value) {
      switch (value) {
        case 'high':
          return 'tag-success';
        case 'medium':
          return 'tag-warning';
        case 'low':
          return 'tag-danger';
        default:
          return '';
      }
    },
    getEmploymentTypeText(value) {
      const option = this.employmentTypes.find(opt => opt.value === value);
      return option.text;
    },
    async downloadFile(id, passportUrl) {
      const fileName = passportUrl.split("/").pop();
      const result = await this.getWorkerFile(id);

      if (result.error || !result.data) {
        this.showError("Ошибка загрузки файла.");
        return;
      }

      this.handleFileDownload(result.data, fileName);
    },
    async onPageChange(page) {
      this.currentPage = page;
      await this.getItems();
    },
  },
}
</script>

<style>
#modal-workers .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}

.sticky-info {
  position: sticky;
  top: 1rem;
  align-self: flex-start;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkersFree.vue